import React, { useState, useEffect } from 'react'
import './gettingstarted.scss';
import SBNav from '../../shared/components/SideBarNav/SBNav';
import Footer from '../../components/Footer/Footer';

const GettingStarted = () => {
    const [nav, openNav] = useState(false);

    useEffect(() => {
        document.title = 'Getting Started'
    }, [])


    useEffect(() => {
        if (!nav) {
            document.documentElement.classList.remove("nav-blur");
            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";
            return;
        }

        const scrollY = window.scrollY;

        document.documentElement.classList.add("nav-blur");

        document.body.style.overflow = "hidden";
        document.body.style.position = "fixed";
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = "100%";

        return () => {
            document.documentElement.classList.remove("nav-blur");
            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";

            window.scrollTo(0, scrollY);
        };
    }, [nav]);

    return (
        <div id="getting-started-page">



            <div className='nav-2'>

                <div className='nav-logo-container'>
                    <img src='images/flashroom-logo-light.png' height="44px" />
                    <h1>Flash<span>Room</span></h1>
                </div>

                <div className='hamburger-menu-2' onClick={() => openNav(true)}>
                    <div />
                    <div />
                    <div />
                </div>

            </div>



            <div className={`nav-cont ${nav ? 'nav-open' : 'nav-closed'}`}>

                <div className='standard-xi-cont'

                    onClick={() => openNav(false)}
                >

                    <svg className="x-icon-sbn" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 111.01 111.01">
                        <g id="Layer_3" data-name="Layer 3">
                            <path
                                className="cls-1"
                                d="M232.21,289.66a10.1,10.1,0,0,1-14.31,0l-38.22-38.22-38.23,38.23a10.13,10.13,0,0,1-14.32-14.32l38.23-38.23L127.14,198.9a10.12,10.12,0,1,1,14.31-14.31l38.22,38.22,38.23-38.23a10.13,10.13,0,0,1,14.32,14.32L194,237.13l38.22,38.22A10.12,10.12,0,0,1,232.21,289.66Z"
                                transform="translate(-124.17 -181.62)"
                            />
                        </g>
                    </svg>

                </div>

                <SBNav />

            </div>
            <div className="gs-content">
                <div className="gs-panel">
                    <div className="gs-header">
                        <div className="gs-badge">Getting Started</div>
                        <h1>How to use FlashRoom</h1>
                    </div>

                    <div className="gs-section">
                        <div className="gs-section-left">
                            <h2>Create a room and choose a mode</h2>
                            <p>
                                Start from <strong>Create Room</strong>. Give the room a short name, then choose the room mode and
                                default access before anyone joins.
                            </p>

                            <ul className="gs-list">
                                <li><strong>Workspace:</strong> best for collaboration, member tracking, names, and managing access.</li>
                                <li><strong>Quick Share:</strong> best for quick file sharing, especially with larger groups where you do not need every person's name.</li>
                                <li><strong>Shareable Link:</strong> lets people enter from the room URL.</li>
                                <li><strong>Default Member Role:</strong> choose read-only access or editor access for new members.</li>
                            </ul>
                        </div>

                        <div className="gs-media">
                            <img
                                src={`${process.env.PUBLIC_URL}/images/howto1.jpg`}
                                alt="Create Room form with room defaults"
                                loading="lazy"
                            />
                            <div className="gs-caption">Choose Workspace for collaboration or Quick Share for fast file sharing.</div>
                        </div>
                    </div>

                    <div className="gs-divider" />

                    <div className="gs-section">
                        <div className="gs-section-left">
                            <h2>Share the join code</h2>
                            <p>
                                After the room opens, the join code appears across the top of the workspace. Put that code on the board,
                                in chat, or on your projector. Students can use the Join page and enter the code exactly as shown.
                            </p>

                            <div className="gs-callout">
                                <strong>Tip:</strong> The code is case sensitive, so copy and paste is safest when you are sending it
                                digitally.
                            </div>
                        </div>

                        <div className="gs-media">
                            <img
                                src={`${process.env.PUBLIC_URL}/images/howto3.jpg`}
                                alt="Workspace join code and editor layout"
                                loading="lazy"
                            />
                            <div className="gs-caption">The top bar keeps the room code visible while you work.</div>
                        </div>
                    </div>

                    <div className="gs-divider" />

                    <div className="gs-section reverse">
                        <div className="gs-section-left">
                            <h2>Work in the editor</h2>
                            <p>
                                The <strong>Workspace</strong> view is where live files open. The left panel lists room files and folders,
                                while the main editor shows open tabs. Use the download, copy, and settings buttons on the active tab when
                                you need the current file.
                            </p>

                            <ul className="gs-list">
                                <li>Click a file in the left panel to open it as a tab.</li>
                                <li>Use the lock control to see whether a file is Read Only or Open.</li>
                                <li>Use the top <strong>Add</strong> button or the sidebar shortcuts to add materials.</li>
                            </ul>
                        </div>

                        <div className="gs-media">
                            <img
                                src={`${process.env.PUBLIC_URL}/images/howto4.jpg`}
                                alt="Download, folder, and file action buttons"
                                loading="lazy"
                            />
                            <div className="gs-caption">The Flash Editor shortcuts handle downloads, folders, and new files.</div>
                        </div>
                    </div>

                    <div className="gs-divider" />

                    <div className="gs-section">
                        <div className="gs-section-left">
                            <h2>Create a new file</h2>
                            <p>
                                Click the <strong>Add File</strong> shortcut or choose New File from the add menu. Name the file with an
                                extension, or pick one of the extension shortcuts. FlashRoom will create the right editor type for that
                                file.
                            </p>

                            <ul className="gs-list">
                                <li><strong>Read Only:</strong> others can view, copy, and download.</li>
                                <li><strong>Open:</strong> editors can type and collaborate in the file.</li>
                            </ul>
                        </div>

                        <div className="gs-media">
                            <img
                                src={`${process.env.PUBLIC_URL}/images/howto5.jpg`}
                                alt="New File form with extension choices"
                                loading="lazy"
                            />
                            <div className="gs-caption">The New File form replaces the old create-file screenshot.</div>
                        </div>
                    </div>

                    <div className="gs-divider" />

                    <div className="gs-section reverse">
                        <div className="gs-section-left">
                            <h2>Organize with folders</h2>
                            <p>
                                Folders keep starter projects, examples, images, and handouts together. Create folders from the sidebar
                                folder button or the add menu, then use folders to separate units, labs, or activity steps.
                            </p>

                            <ul className="gs-list">
                                <li><strong>Restricted:</strong> only people with permission can add to the folder.</li>
                                <li><strong>Open:</strong> editors can drop work into the folder.</li>
                                <li>Folder uploads keep nested project structure intact.</li>
                            </ul>
                        </div>

                        <div className="gs-media">
                            <img
                                src={`${process.env.PUBLIC_URL}/images/howto6.jpg`}
                                alt="Folder and file controls in the editor sidebar"
                                loading="lazy"
                            />
                            <div className="gs-caption">The sidebar shows folder controls beside the file controls.</div>
                        </div>
                    </div>

                    <div className="gs-divider" />

                    <div className="gs-section">
                        <div className="gs-section-left">
                            <h2>Manage file settings</h2>
                            <p>
                                You can open file settings from more than one place. Use the settings button on the active file,
                                right-click a file in the Workspace file list, or open the file from Drive and use its file actions.
                            </p>
                            <p>
                                Permissions are simple on purpose: <strong>Read Only</strong> is for viewing, copying, and downloading;
                                <strong>Open</strong> lets editors collaborate directly in the file.
                            </p>

                            <ul className="gs-list">
                                <li><strong>Workspace:</strong> use the active file settings button or right-click a file in the sidebar.</li>
                                <li><strong>Drive:</strong> open or select a file, then use the available file actions.</li>
                                <li>Settings are where you rename, change permissions, or remove a file.</li>
                            </ul>

                            <div className="gs-callout">
                                <strong>Quick check:</strong> the lock pill at the bottom of the editor always shows the active file's
                                current permission state.
                            </div>
                        </div>

                        <div className="gs-media">
                            <img
                                src={`${process.env.PUBLIC_URL}/images/howto7.jpg`}
                                alt="File settings and permission controls"
                                loading="lazy"
                            />
                            <div className="gs-caption">Use file settings to rename, change permissions, or remove a file.</div>
                        </div>
                    </div>

                    <div className="gs-divider" />

                    <div className="gs-section reverse">
                        <div className="gs-section-left">
                            <h2>Download with selection mode</h2>
                            <p>
                                You can download from either <strong>Workspace</strong> or <strong>Drive</strong>. Use the active file
                                download button when you only need the file currently open in the editor. Use selection mode when you
                                want more than one thing.
                            </p>
                            <ul className="gs-list">
                                <li><strong>Top editor button:</strong> downloads the active open file.</li>
                                <li><strong>Workspace sidebar:</strong> click the Flash Editor download button, select files or folders, then download.</li>
                                <li><strong>Right-click:</strong> right-click files or folders in the Workspace file list to download them directly.</li>
                                <li><strong>Drive:</strong> switch to Drive, click <strong>Select</strong>, choose files or folders, then download.</li>
                                <li><strong>Single item:</strong> downloads directly. <strong>Multiple items or folders:</strong> download as a zip.</li>
                            </ul>
                        </div>

                        <div className="gs-media-pair">
                            <div className="gs-media gs-media-compact">
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/howto8.jpg`}
                                    alt="Download selection mode in the file sidebar"
                                    loading="lazy"
                                />
                                <div className="gs-caption">Workspace downloads support active-file, right-click, and selection flows.</div>
                            </div>

                            <div className="gs-media gs-media-compact">
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/howto9.jpg`}
                                    alt="Drive select mode and download controls"
                                    loading="lazy"
                                />
                                <div className="gs-caption">Drive selection mode lets you choose files or folders before downloading.</div>
                            </div>
                        </div>
                    </div>

                    <div className="gs-divider" />

                    <div className="gs-section gs-last">
                        <div className="gs-section-left">
                            <h2>Switch to Drive when you need to browse</h2>
                            <p>
                                <strong>Drive</strong> is the room file browser. Use it when you want to search, sort, filter, or scan
                                everything in the room without opening each item in the editor.
                            </p>
                            <ul className="gs-list">
                                <li>Sort by name, date, or size.</li>
                                <li>Filter by folders, code, text, documents, or media.</li>
                                <li>Open files from Drive when you are ready to edit or preview them.</li>
                            </ul>

                        </div>

                        <div className="gs-media">
                            <img
                                src={`${process.env.PUBLIC_URL}/images/howto10.jpg`}
                                alt="Drive view with sort and filter controls"
                                loading="lazy"
                            />
                            <div className="gs-caption">Drive gives the room a sortable, filterable file view.</div>
                        </div>
                    </div>

                    <div className="gs-divider" />

                    <div className="gs-section reverse">
                        <div className="gs-section-left">
                            <h2>Upload files and folders</h2>
                            <p>
                                Use the <strong>Add</strong> menu to upload files or whole folders. Uploading a code file, like an HTML,
                                CSS, JS, Python, or text file, can turn it into an editable FlashRoom file. Other supported file types
                                can be previewed or downloaded by the room.
                            </p>
                            <ul className="gs-list">
                                <li><strong>Upload File:</strong> add one or more files from your computer.</li>
                                <li><strong>Upload Folder:</strong> keep a project folder together when you bring it into the room.</li>
                                <li>Uploaded folders can preserve nested structure up to the room's folder-depth limit.</li>
                            </ul>
                        </div>

                        <div className="gs-media-pair">
                            <div className="gs-media gs-media-compact">
                                <img
                                    className="gs-image-smaller"
                                    src={`${process.env.PUBLIC_URL}/images/howto11.jpg`}
                                    alt="Upload file option in the Add menu"
                                    loading="lazy"
                                />
                                <div className="gs-caption">Use Upload File when you want to bring in one or more individual files.</div>
                            </div>

                            <div className="gs-media gs-media-compact">
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/howto12.jpg`}
                                    alt="Upload folder option in the Add menu"
                                    loading="lazy"
                                />
                                <div className="gs-caption">Use Upload Folder when you want to keep a project folder together.</div>
                            </div>
                        </div>
                    </div>

                    <div className="gs-divider" />

                    <div className="gs-section">
                        <div className="gs-section-left">
                            <h2>Use Room Settings</h2>
                            <p>
                                Room owners can open the Settings panel from the sidebar. This is where you manage how people enter,
                                whether members are tracked, how many people can join, and what role new members receive by default.
                            </p>
                            <ul className="gs-list">
                                <li><strong>Shareable Link:</strong> let people join directly from the room URL.</li>
                                <li><strong>Track Members:</strong> show names, presence, and member controls.</li>
                                <li><strong>Max Members:</strong> cap the room size when you need a smaller group.</li>
                                <li><strong>Default Member Role:</strong> choose whether new members join read-only or as editors.</li>
                            </ul>
                        </div>

                        <div className="gs-media">
                            <img
                                src={`${process.env.PUBLIC_URL}/images/howto13.jpg`}
                                alt="Room settings sidebar panel"
                                loading="lazy"
                            />
                            <div className="gs-caption">Room Settings controls how people join and what access new members receive.</div>
                        </div>
                    </div>

                    <div className="gs-divider" />

                    <div className="gs-section reverse">
                        <div className="gs-section-left">
                            <h2>Manage people and roles</h2>
                            <p>
                                When member tracking is on, the Members panel shows who is in the room. Owners and admins can manage
                                access so students or teammates only get the permissions they need.
                            </p>
                            <div className="gs-mini-grid">
                                <div className="gs-mini">
                                    <h3>Owner</h3>
                                    <p>Can manage the room, settings, members, files, folders, and permissions.</p>
                                </div>
                                <div className="gs-mini">
                                    <h3>Admin</h3>
                                    <p>Can help manage room content and members without replacing the owner.</p>
                                </div>
                                <div className="gs-mini">
                                    <h3>Editor</h3>
                                    <p>Can create, upload, edit, organize, copy, and download room materials.</p>
                                </div>
                                <div className="gs-mini">
                                    <h3>Read Only</h3>
                                    <p>Can view, copy, and download without changing room content.</p>
                                </div>
                            </div>
                        </div>

                        <div className="gs-media">
                            <img
                                src={`${process.env.PUBLIC_URL}/images/howto14.jpg`}
                                alt="Members panel and role controls"
                                loading="lazy"
                            />
                            <div className="gs-caption">The Members panel shows who is in the room and which role each person has.</div>
                        </div>
                    </div>

                    <div className="gs-divider" />

                    <div className="gs-section">
                        <div className="gs-section-left">
                            <h2>Use the lower sidebar controls</h2>
                            <p>
                                The lower sidebar area is where you manage personal room controls. Click your name to rename yourself,
                                use the theme control to switch between light and dark mode, and check the room's total storage usage.
                            </p>
                            <ul className="gs-list">
                                <li>Use a name people in the room will recognize.</li>
                                <li>Renaming updates how you appear in the room.</li>
                                <li>Theme changes only affect how FlashRoom looks for you.</li>
                                <li>The storage total shows how much room storage is currently being used.</li>
                            </ul>
                        </div>

                        <div className="gs-media">
                            <img
                                src={`${process.env.PUBLIC_URL}/images/howto15.jpg`}
                                alt="Lower sidebar profile, theme, and storage controls"
                                loading="lazy"
                            />
                            <div className="gs-caption">The lower sidebar keeps your name, theme toggle, and room storage total together.</div>
                        </div>
                    </div>




                </div>
            </div>

            <Footer />
        </div>
    )
}

export default GettingStarted
